<img class="back" (click)="back()" src="/assets/images/back.png"
     srcset="/assets/images/back.png 1x, /assets/images/back_2x.png 2x">